import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en/translation.json';
import translationPT from './locales/pt/translation.json';
import translationES from './locales/es/translation.json';
i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector) //detecta automaticamente o idioma do navegador e armazena em um cookie
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
    resources: {
        en: {
            translation: translationEN,
        },
        pt: {
            translation: translationPT,
        },
        es: {
            translation: translationES,
        }
    },
    debug: true,
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
});
export default i18n;
//# sourceMappingURL=i18n.js.map